import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ContextService } from '../../services/context/context.service';
import { RequestMapper } from '../../request-mapper';

// Post-login gate. Shown only when a choice is needed:
//  1. the operator has BOTH global and establishment access -> pick a scope;
//  2. establishment scope with more than one establishment -> pick which one.
// A single obvious context is applied by the loader without landing here.
@Component({
  selector: 'app-context-select',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './context-select.component.html',
  styleUrl: './context-select.component.scss',
})
export class ContextSelectComponent implements OnInit {
  step: 'scope' | 'establishment' = 'scope';
  establishments: any[] = [];

  constructor(
    private contextService: ContextService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.establishments = this.contextService.establishmentBuckets();
    if (this.contextService.needsScopeChoice()) {
      this.step = 'scope';
    } else if (this.contextService.needsEstablishmentChoice()) {
      this.step = 'establishment';
    } else {
      // nothing to choose — apply the obvious context and move on
      this.contextService.applyDefault();
      this.land();
    }
  }

  chooseGlobal(): void {
    this.contextService.applyGlobal();
    this.land();
  }

  chooseEstablishmentScope(): void {
    if (this.contextService.needsEstablishmentChoice()) {
      this.step = 'establishment';
      return;
    }

    const establishmentId = Number(this.establishments[0]?.establishmentId);
    this.chooseEstablishment(establishmentId);
  }

  chooseEstablishment(establishmentId: number): void {
    if (this.contextService.applyEstablishment(Number(establishmentId))) {
      this.land();
    }
  }

  private land(): void {
    const route = this.contextService.firstRoute();
    if (route) this.router.navigate([RequestMapper.SIDENAV, route]);
    else this.router.navigate([RequestMapper.SIDENAV]);
  }
}
